import React from "react";
import Space from "../../commons/Space";
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./DanzaInfoCorsi.css"

function DanzaInfoCorsi() {
    return(
        <div className="info-corsi" style={{width: "80%", margin: "auto"}}>
            <dl className="row align-content-center" >
                <dt className="col-sm-3">Cheerleading</dt>
                <dd className="col-sm-9 mb-4">
                    Insieme alla ex campionessa europea, lezioni super dinamiche, cariche di energia, allenanti e acrobatiche. Creano sinergia di gruppo e preparano a lavoro performativo.
                </dd>


                <dt className="col-sm-3">International</dt>
                <dd className="col-sm-9 mb-4">
                    Lezione di danza moderna in cui creatività e tecnica si fondono in modo armonico, particolarmente curata sotto l’aspetto della flessibilità e dell’eleganza del movimento. La maestra pluridiplomata è tra le migliori insegnanti del panorama nazionale e internazionale di danza moderna e contemporanea.
                </dd>

                <dt className="col-sm-3">Moderno</dt>
                <dd className="col-sm-9 mb-4">
                    Lezioni di tecnica moderna con particolare attenzione alla pulizia del movimento, alla coordinazione e all’atleticità del danzatore. Tutto con musiche attuali, adatte al lavoro e al livello dell’allievo. Gli insegnanti sono tutti altamente qualificati e selezionati con cura
                </dd>

                <dt className="col-sm-3">Contemporaneo</dt>
                <dd className="col-sm-9 mb-4">
                    Lezioni di tecnica contemporanea, costruite in base al livello dei danzatori, con particolare attenzione al lavoro a terra, alla fusione con altri stili e alla dinamica del corpo. Tutto con musiche ricercate e adatte al tipo di sviluppo del movimento danzato. Gli insegnati sono tutti diplomati in prestigiose accademie o giovani ballerini professionisti.
                </dd>

                <dt className="col-sm-3">Classico</dt>
                <dd className="col-sm-9 mb-4">
                    Lezioni dedicate a due livelli di danzatori: uno amatoriale, per i più giovani e uno semi professionale. Abbiamo maestre selezionate appositamente per i più piccoli e l’insegnante Matteo Donetti (tra i più ricercati per le classi di classico in Lombardia) per il corso semi professionale.
                </dd>

                <dt className="col-sm-3">Experience</dt>
                <dd className="col-sm-9 mb-4">
                    Lezioni con la nostra direttrice artistica (supportata da tutto lo staff di insegnanti del Cigno) dedicate a danzatori con obiettivi performativi e “agonistici”.
                    Il lavoro è tecnicamente e artisticamente di altissimo livello. Prevede trasferte in Italia e all’estero, show in teatri o location prestigiose, concorsi e gare
                </dd>

                <dt className="col-sm-3">Hip Hop</dt>
                <dd className="col-sm-9 mb-4">
                    Lezioni dinamiche e con ritmi entusiasmanti e allenanti (sia fisicamente che ritmicamente). La maestra è un’ ex ballerina di hip hop in video clip e film musicali. Adatto a tutti i livelli di preparazione.
                </dd>

            </dl>
        </div>
    )
}

export default DanzaInfoCorsi